import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { getAuthLoginEndpointUrl, REDIRECT_AFTER_LOGIN_KEY } from '@/config';

const rawBaseQuery = fetchBaseQuery({ baseUrl: window.location.origin, credentials: 'same-origin' });

const nonAbortingSignalBaseQuery = async (args, api, extraOptions) => {
    const result = await rawBaseQuery(args, { ...api, signal: undefined }, extraOptions);

    if (result.error?.status === 401) {
        localStorage.setItem(
            REDIRECT_AFTER_LOGIN_KEY,
            window.location.pathname + window.location.search + window.location.hash,
        );
        window.location.assign(getAuthLoginEndpointUrl());
    }

    return result;
};

export { nonAbortingSignalBaseQuery };
